import createPaginatedAsyncThunk from 'redux/utils/createPaginatedAsyncThunk';
import PageSettingsAPI from './services';

export const fetchPageSettings = createPaginatedAsyncThunk('pageSettings/fetchAll', async ({ params = {} }) => {
  const response = await PageSettingsAPI.fetchAll({ params });
  return params.group ? { [params.group]: response.data } : response.data;
});
